import { A } from '@solidjs/router'
import { onCleanup } from 'solid-js'
import { getAssetUrl } from '/web/shared/util'
import { settingStore } from '/web/store'
import { getModelUrl } from '/web/shared/aifans/lib/model-util'
import { AppSchema } from '/common/types'

interface Props {
  image?: string
  name?: string
  id?: string
  opened?: boolean
  character?: AppSchema.Character
}

const ChatHeaderAiFans = (props: Props) => {
  const state = settingStore()

  onCleanup(() => {
    // reset right nav when component unmounts
    settingStore.rightNav(true)
    settingStore.rightNavMobile()
  })

  return (
    <div class="flex flex-1 items-center justify-between border-b border-b-cosplay-gray-100 p-4 pl-2 md:pl-4">
      <div class="flex items-center">
        <button
          class="mr-2 md:hidden"
          onClick={() => {
            settingStore.leftPanelMobile(true)
          }}
        >
          <img src="/images/icons/arrow-back.svg" class="h-9 w-9" />
        </button>
        {props.image && (
          <div class="relative h-12 w-12 overflow-hidden rounded-full border-2 border-white">
            <A href={getModelUrl(props.character?.categorySlug, props.character?.slug || props.id)}>
              <img
                class="absolute h-full w-full object-cover"
                src={getAssetUrl(props.image)}
                alt="user"
              />
            </A>
          </div>
        )}

        <A href={getModelUrl(props.character?.categorySlug, props.character?.slug || props.id)}>
          <h1 class="ml-3 font-clash text-2xl font-bold">{props.name}</h1>
        </A>
      </div>
      <button
        class={`hidden md:block ${state.showRightNav ? 'rotate-180' : ''}`}
        onClick={() => settingStore.rightNav(!state.showRightNav)}
      >
        <img src="/images/open-panel-button.png" class="w-9" />
      </button>
      <button
        class={`md:hidden ${!state.showRightNavMobile ? 'rotate-180' : ''}`}
        onClick={() => {
          settingStore.rightNav(true)
          settingStore.rightNavMobile()
        }}
      >
        <img src="/images/open-panel-button.png" class="w-9" />
      </button>
    </div>
  )
}

export default ChatHeaderAiFans
